import { createContext, useContext, useState } from "react";
import AuditDialog from "./AuditDialog";
import BookCallDialog from "./BookCallDialog";

const DialogsContext = createContext(null);

export const useDialogs = () => {
  const ctx = useContext(DialogsContext);
  if (!ctx) throw new Error("useDialogs must be inside DialogsProvider");
  return ctx;
};

export function DialogsProvider({ children }) {
  const [auditOpen, setAuditOpen] = useState(false);
  const [bookOpen, setBookOpen] = useState(false);

  return (
    <DialogsContext.Provider
      value={{
        openAudit: () => setAuditOpen(true),
        openBook: () => setBookOpen(true),
      }}
    >
      {children}
      <AuditDialog open={auditOpen} onOpenChange={setAuditOpen} />
      <BookCallDialog open={bookOpen} onOpenChange={setBookOpen} />
    </DialogsContext.Provider>
  );
}
